export default __webpack_public_path__ + "static/arbias-office-5ea66d6adbd2ac0a63efbc1471f9b682.jpg";